module.exports = "<div class=\"loader hide\">\r\n<div class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.html
// module id = ./src/app/loader/loader.component.html
// module chunks = main